import { useState } from 'react'
import { Button, Input } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGridHorizontal } from '@fortawesome/pro-solid-svg-icons/faGridHorizontal'
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { DraggableProvided } from 'react-beautiful-dnd'
import { IQuestionBankSection } from 'interfaces/questionBank'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { slices } from 'store/slices'
import Information from '../information'
import { Wrapper, Title, Actions } from './styled'

interface IProps {
  section: IQuestionBankSection
  provided: DraggableProvided
  isOpen: boolean
  setIsOpen: (value: boolean) => void
}

const Header = ({ section, provided, isOpen, setIsOpen }: IProps) => {
  const dispatch = useAppDispatch()
  const [isChangingTitle, setIsChangingTitle] = useState(false)
  const data = useAppSelector(slices.questionBank.data)

  const onBlur = () => {
    setIsChangingTitle(false)
    dispatch(slices.questionBank.validateSectionName(section.order))
  }

  return (
    <Wrapper
      isOpen={isOpen}
      isChangingTitle={isChangingTitle}
      isEmpty={section.questions.length === 0}
    >
      <Title>
        <Button {...provided.dragHandleProps}>
          <FontAwesomeIcon icon={faGridHorizontal} />
        </Button>
        {isChangingTitle ? (
          <Input
            value={section.name}
            onBlur={onBlur}
            autoFocus={true}
            onChange={(event: { target: { value: string } }) =>
              dispatch(
                slices.questionBank.changeSectionName({
                  sectionOrder: section.order,
                  sectionName: event.target.value,
                })
              )
            }
          />
        ) : (
          <div onClick={() => setIsChangingTitle(true)}>{section.name}</div>
        )}
        <Button onClick={() => setIsChangingTitle(true)}>
          <FontAwesomeIcon icon={faPen} />
        </Button>
      </Title>
      <Actions>
        {!isOpen && !isChangingTitle && section.questions.length > 0 && (
          <Information section={section} />
        )}
        <Button
          onClick={() =>
            dispatch(slices.questionBank.removeSection(section.order))
          }
          disabled={data.sections.length === 1}
        >
          <FontAwesomeIcon icon={faTrash} />
        </Button>
        <Button onClick={() => setIsOpen(!isOpen)}>
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </Button>
      </Actions>
    </Wrapper>
  )
}

export default Header
